export const locale = {
    lang: "es",
    data: {
        MYORDERS: {
            MYORDERS: "Mis Pedidos",
        },
    },
};
